export const errorPrefix = (prefix: string, error: Error): Error => {
  error.message = `${prefix} ${error.message}`;

  return error;
};
